<app-landing></app-landing>
<app-usp></app-usp>
<app-services></app-services>
<app-about></app-about>
<app-prices></app-prices>
<app-contact></app-contact>
<app-blog-showcase></app-blog-showcase>
<app-about-your-next-project></app-about-your-next-project>
